import { render, staticRenderFns } from "./gallery-folder-recucler-list.vue?vue&type=template&id=46b5ddc4&"
import script from "./gallery-folder-recucler-list.vue?vue&type=script&lang=ts&"
export * from "./gallery-folder-recucler-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports